// Arabic strings for the app shell, navigation, sign-in / account pages, help drawer and shared components.
// Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " and ": " و",
  ".": " الخاصة بنظام AssetOS.",
  ". If you do not see it shortly, check your spam or junk folder.": ". إذا لم يصلك قريباً، فتحقق من مجلد البريد العشوائي أو غير المرغوب فيه.",
  "15 minutes": "15 دقيقة",
  "Accept your invitation": "اقبل دعوتك",
  "Access denied": "تم رفض الوصول",
  "Account Plans & Billing": "خطط الحساب والفوترة",
  "Account Subscription & Plans": "اشتراك الحساب والخطط",
  "Accounts are created by invitation from your property administrator": "تُنشأ الحسابات بدعوة من مسؤول العقار",
  "All {app} Modules": "جميع وحدات {app}",
  "Allow NFC for this site to read tags.": "اسمح لهذا الموقع باستخدام NFC لقراءة الوسوم.",
  "Already have an account?": "لديك حساب بالفعل؟",
  "An unexpected error occurred. Please try again in a moment.": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى بعد قليل.",
  "and acknowledge the": "وأقر بـ",
  "and {count} more notes": "و{count} ملاحظات أخرى",
  "API & Webhooks": "واجهات API وخطافات الويب",
  "Ask your property administrator to invite you from the User Directory, then open the link in your invitation email.": "اطلب من مسؤول العقار دعوتك من دليل المستخدمين، ثم افتح الرابط في رسالة الدعوة.",
  "Asset Custody & Movements": "عهدة الأصول وحركاتها",
  "Asset Disposals & Write-Offs": "استبعاد الأصول وشطبها",
  "Asset Lookup": "البحث عن أصل",
  "Asset Quick View": "عرض سريع للأصل",
  "Asset Valuation & Analytics Dashboard": "لوحة تقييم الأصول والتحليلات",
  "Assigned Property": "العقار المخصص",
  "Audit": "الجرد",
  "Audit Reconciliation Console": "وحدة تسوية الجرد",
  "Audit Schedules & Coverage": "جداول الجرد والتغطية",
  "Back to home": "العودة إلى الرئيسية",
  "Back to Sign In": "العودة إلى تسجيل الدخول",
  "Back to sign in": "العودة إلى تسجيل الدخول",
  "Banquet Event Kits": "مجموعات الحفلات والمناسبات",
  "Banquet Event Kits & Batch Reconciliation": "مجموعات الحفلات وتسوية الدفعات",
  "Banquet Event Kits & Reconciliation": "مجموعات الحفلات والتسوية",
  "Blind Counts & Variance Console": "وحدة العد الأعمى والفروقات",
  "Book Policies & Opening Balances": "سياسات الدفاتر والأرصدة الافتتاحية",
  "Books": "الدفاتر",
  "By signing in, you agree to AssetOS ": "بتسجيل الدخول، فإنك توافق على ",
  "Camera Scan HUD": "مسح بالكاميرا",
  "Catalogue": "الكتالوج",
  "Check your inbox": "تحقق من بريدك الوارد",
  "Checking your invitation...": "جارٍ التحقق من دعوتك...",
  "Choose a new password": "اختر كلمة مرور جديدة",
  "Close help": "إغلاق المساعدة",
  "Completing Repair Records": "إكمال سجلات الإصلاح",
  "Concurrent management, tax, and statutory ledgers with automated GL journal exports.": "دفاتر إدارية وضريبية ونظامية متزامنة مع تصدير آلي لقيود دفتر الأستاذ.",
  "Confirm New Password": "تأكيد كلمة المرور الجديدة",
  "Confirm Password": "تأكيد كلمة المرور",
  "Connected Platforms": "المنصات المتصلة",
  "Contents": "المحتويات",
  "Corporate Email": "البريد الإلكتروني للشركة",
  "Corporate Email Address": "البريد الإلكتروني للشركة",
  "Counts come from the exception rules. A summary is written only from those counts; otherwise the notes are listed as entered.": "تأتي الأعداد من قواعد الاستثناءات. لا يُكتب الملخص إلا من هذه الأعداد؛ وإلا تُعرض الملاحظات كما أُدخلت.",
  "Create Account": "إنشاء حساب",
  "Create user account": "إنشاء حساب مستخدم",
  "Creating Account...": "جارٍ إنشاء الحساب...",
  "Creating an Account": "إنشاء حساب",
  "Demo": "تجريبي",
  "Demo accounts — 1-click test sign-in": "حسابات تجريبية — تسجيل دخول اختباري بنقرة واحدة",
  "Demo sign-in failed": "تعذّر تسجيل الدخول التجريبي",
  "Department": "القسم",
  "Depreciation Runs & GL Schedules": "تشغيل الإهلاك وجداول دفتر الأستاذ",
  "Did not receive an email? Click above to resend.": "لم يصلك بريد؟ انقر أعلاه لإعادة الإرسال.",
  "Dispatching link...": "جارٍ إرسال الرابط...",
  "Drafted by language assist": "صاغه مساعد اللغة",
  "e.g. Maria Rodriguez": "مثال: ماريا رودريغيز",
  "Email or password is incorrect": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "Enter your corporate email address and we'll send you a secure link to reset your password.": "أدخل البريد الإلكتروني للشركة وسنرسل إليك رابطاً آمناً لإعادة تعيين كلمة المرور.",
  "Enter your work email first so we can find your organisation’s sign-in.": "أدخل بريد العمل أولاً لنعثر على تسجيل الدخول الخاص بمؤسستك.",
  "Enterprise Hospitality Fixed Asset Operating System": "نظام إدارة الأصول الثابتة الفندقية المتكامل",
  "Event Kits": "مجموعات المناسبات",
  "Exception Queue": "قائمة الاستثناءات",
  "Exceptions": "الاستثناءات",
  "Executive Asset Dashboard": "لوحة الأصول التنفيذية",
  "Export": "تصدير",
  "Fair": "مقبول",
  "FAQ": "الأسئلة الشائعة",
  "Field App": "التطبيق الميداني",
  "field screens": "الشاشات الميدانية",
  "First Scan": "المسح الأول",
  "First Scan Walk Binding": "ربط الوسوم في جولة المسح الأول",
  "First-Scan Walk": "جولة المسح الأول",
  "Fixed Asset Register (FAR) Report": "تقرير سجل الأصول الثابتة (FAR)",
  "Forgot Password": "نسيت كلمة المرور",
  "Forgot password?": "نسيت كلمة المرور؟",
  "Full Legal Name": "الاسم القانوني الكامل",
  "Getting Started": "البدء",
  "Go to sign in": "الانتقال إلى تسجيل الدخول",
  "Good": "جيد",
  "Guest Loaners": "معدات إعارة النزلاء",
  "Guest Loaners & Overdue Tracker": "إعارات النزلاء ومتابعة المتأخرات",
  "Help": "المساعدة",
  "Hold the tag to the phone…": "قرّب الوسم من الهاتف…",
  "How to get access": "كيفية الحصول على صلاحية الدخول",
  "I agree to the": "أوافق على",
  "IAS 16 cost model with USALI operating department allocation and automated Xero GL manual journals.": "نموذج تكلفة IAS 16 مع توزيع نفقات الإهلاك على أقسام تشغيل الفندق وتصدير قيود Xero الآلية.",
  "If an account exists for that email, we've sent a recovery link.": "إذا كان هناك حساب لهذا البريد، فقد أرسلنا رابط استعادة.",
  "Integration Fabric Connectors": "موصلات منصة التكامل",
  "Inwarding & Asset Tagging": "الاستلام ووسم الأصول",
  "It may have expired or already been used. Ask your property administrator to send you a new invitation.": "ربما انتهت صلاحيتها أو استُخدمت. اطلب من مسؤول العقار إرسال دعوة جديدة.",
  "Join your property's asset operations team to audit rooms, track equipment lifecycle, and streamline multi-book financial reporting.": "انضم إلى فريق عمليات الأصول في عقارك لجرد الغرف وتتبع دورة حياة المعدات وتبسيط التقارير المالية متعددة الدفاتر.",
  "Language & Arabic (RTL)": "اللغة والعربية (من اليمين لليسار)",
  "Linen Laundry": "مغسلة البياضات",
  "Loading properties...": "جارٍ تحميل العقارات...",
  "Loading…": "جارٍ التحميل…",
  "Loaners": "الإعارات",
  "Maintenance Incident Logging": "تسجيل حوادث الصيانة",
  "Maintenance Incidents": "حوادث الصيانة",
  "Maintenance incidents": "حوادث الصيانة",
  "Maintenance incidents: {count} active": "حوادث الصيانة: {count} نشطة",
  "Managing Users": "إدارة المستخدمين",
  "Minimum 8 characters with numbers & symbols": "8 أحرف على الأقل مع أرقام ورموز",
  "Mobile App Navigation": "التنقل في تطبيق الجوال",
  "Mobile Audits & Blind Counts": "الجرد عبر الجوال والعد الأعمى",
  "Mobile Physical Audits & Par Management": "الجرد الميداني وإدارة المخزون المجمع",
  "Monthly Depreciation Run & GL Export": "تشغيل الإهلاك الشهري وتصدير دفتر الأستاذ",
  "Multi-Book USALI & Tax Depreciation": "إهلاك USALI والضريبي متعدد الدفاتر",
  "Must be at least 8 characters with an uppercase letter, a number, and a special symbol.": "يجب ألا تقل عن 8 أحرف وتتضمن حرفاً كبيراً ورقماً ورمزاً خاصاً.",
  "Must be at least 8 characters with an uppercase letter, number, and special symbol.": "يجب ألا تقل عن 8 أحرف وتتضمن حرفاً كبيراً ورقماً ورمزاً خاصاً.",
  "Need an account? ": "ليس لديك حساب؟ ",
  "New Password": "كلمة المرور الجديدة",
  "NFC is switched off or not available on this phone.": "خاصية NFC متوقفة أو غير متاحة على هذا الهاتف.",
  "No notes were written this week.": "لم تُكتب أي ملاحظات هذا الأسبوع.",
  "No weekly summary yet. Summaries are made every Monday for the week before, or select Summarise this week.": "لا يوجد ملخص أسبوعي بعد. تُعد الملخصات كل يوم اثنين عن الأسبوع السابق، أو اختر تلخيص هذا الأسبوع.",
  "No weekly summary yet. Summaries are made every Monday for the week before.": "لا يوجد ملخص أسبوعي بعد. تُعد الملخصات كل يوم اثنين عن الأسبوع السابق.",
  "Not entered": "لم تُدخل",
  "Offline": "غير متصل",
  "Offline-ready room audits, deterministic conflict resolution, and pooled inventory par replenishment.": "جرد الغرف دون اتصال بالإنترنت، تسوية التعارضات تلقائياً، وإعادة ملء مستويات البار للمفروشات والأواني.",
  "Offline-ready room audits, instant discrepancy tagging, and financial variance reconciliation.": "جرد الغرف دون اتصال، ووسم الفروقات فوراً، وتسوية الفروقات المالية.",
  "Offline: actions are saved on this device and synced later": "غير متصل: تُحفظ الإجراءات على هذا الجهاز وتُزامن لاحقاً",
  "Open help": "فتح المساعدة",
  "Opening Inventory": "المخزون الافتتاحي",
  "OR": "أو",
  "Page not found": "الصفحة غير موجودة",
  "Password": "كلمة المرور",
  "Password is required": "كلمة المرور مطلوبة",
  "Password must meet the security policy rules": "يجب أن تستوفي كلمة المرور قواعد سياسة الأمان",
  "Password strength: {label}": "قوة كلمة المرور: {label}",
  "Passwords do not match": "كلمتا المرور غير متطابقتين",
  "Physical Audit Verification": "التحقق الفعلي بالجرد",
  "Please enter a valid corporate email address": "يرجى إدخال بريد إلكتروني صالح للشركة",
  "Please enter your full name": "يرجى إدخال اسمك الكامل",
  "Please select your department": "يرجى اختيار قسمك",
  "Please select your primary property": "يرجى اختيار عقارك الرئيسي",
  "Privacy Policy": "سياسة الخصوصية",
  "Proceed to Sign In": "المتابعة إلى تسجيل الدخول",
  "Property": "العقار",
  "Property & Location Registry": "سجل العقارات والمواقع",
  "Quick View": "عرض سريع",
  "Re-enter your password": "أعد إدخال كلمة المرور",
  "Registration is by invitation only": "التسجيل بالدعوة فقط",
  "Reporting Maintenance Incidents": "الإبلاغ عن حوادث الصيانة",
  "Request a new link": "طلب رابط جديد",
  "Resend link": "إعادة إرسال الرابط",
  "Reset your password": "إعادة تعيين كلمة المرور",
  "Resetting Your Password": "إعادة تعيين كلمة المرور",
  "Return to Sign In": "العودة إلى تسجيل الدخول",
  "Room Contents Sheet": "كشف محتويات الغرفة",
  "Room Kit Templates & Stamping": "قوالب مجموعات الغرف وختمها",
  "Room Stamping & Barcode Registry": "ختم الغرف وسجل الباركود",
  "Room Stamping & Opaque ULID Tags": "ختم الغرف وبطاقات ULID المشفرة",
  "Select department...": "اختر القسم...",
  "Select hotel property...": "اختر العقار الفندقي...",
  "Send Recovery Link": "إرسال رابط الاستعادة",
  "Sending Link...": "جارٍ إرسال الرابط...",
  "Sign In": "تسجيل الدخول",
  "Sign in": "تسجيل الدخول",
  "Sign in required": "يلزم تسجيل الدخول",
  "Sign In to Dashboard": "تسجيل الدخول إلى لوحة التحكم",
  "Sign in to manage hotel property fixed assets and operations": "تسجيل الدخول لإدارة أصول وعمليات المنشآت الفندقية",
  "Sign in with your organisation": "تسجيل الدخول عبر مؤسستك",
  "Sign-in did not complete": "لم يكتمل تسجيل الدخول",
  "Sign-in with your organisation did not complete. Please try again or use your email and password.": "لم يكتمل تسجيل الدخول عبر مؤسستك. حاول مرة أخرى أو استخدم بريدك الإلكتروني وكلمة المرور.",
  "Sign-in with your organisation did not complete. Please try again.": "لم يكتمل تسجيل الدخول عبر مؤسستك. يرجى المحاولة مرة أخرى.",
  "Sign-in with your organisation was cancelled.": "أُلغي تسجيل الدخول عبر مؤسستك.",
  "Signing In": "تسجيل الدخول",
  "Signing you in…": "جارٍ تسجيل دخولك…",
  "Single IFRS Book & USALI Allocations": "دفتر IFRS موحد وتوزيعات USALI",
  "Single sign-on could not be started. Use your email and password.": "تعذّر بدء الدخول الموحد. استخدم بريدك الإلكتروني وكلمة المرور.",
  "Something went wrong": "حدث خطأ ما",
  "Standardized room kit blueprints with tamper-evident QR codes and 6-character short codes.": "مخططات قياسية للغرف مع رموز استجابة سريعة QR غير قابلة للتلاعب ورموز مختصرة من 6 خانات.",
  "Standardized room kits with serialized QR and barcode tracking across hotel buildings and wings.": "مجموعات غرف قياسية مع تتبع برموز QR وباركود مسلسلة عبر مباني الفندق وأجنحته.",
  "Stock": "المخزون",
  "Stock & Par": "المخزون والبار",
  "Stock Points & Par": "نقاط المخزون والبار",
  "Stock Points & Par Management": "نقاط المخزون وإدارة البار",
  "Streamlined property onboarding, room-level asset stamping, physical audit walks, native repair records, and automated single-book IAS 16 depreciation.": "تبسيط تسجيل العقارات، ختم الغرف بالأصول، جولات الجرد الفعلي الميدانية، سجلات الصيانة المباشرة، وحساب الإهلاك الفندقي وفق معيار IAS 16.",
  "Strong": "قوية",
  "Summarise this week": "تلخيص هذا الأسبوع",
  "Summarising…": "جارٍ التلخيص…",
  "Sync": "المزامنة",
  "Sync Status": "حالة المزامنة",
  "Tag Generation & Binding": "إنشاء الوسوم وربطها",
  "Tag Generation & Binding Console": "وحدة إنشاء الوسوم وربطها",
  "Tag Studio": "استوديو الوسوم",
  "Tap NFC tag": "المس وسم NFC",
  "Terms of Service": "شروط الخدمة",
  "That sign-in attempt expired. Please try again.": "انتهت صلاحية محاولة تسجيل الدخول. يرجى المحاولة مرة أخرى.",
  "The email your invitation was sent to": "البريد الإلكتروني الذي أُرسلت إليه دعوتك",
  "The page you are looking for does not exist or has not been built yet.": "الصفحة التي تبحث عنها غير موجودة أو لم تُنشأ بعد.",
  "The secure recovery link expires in": "تنتهي صلاحية رابط الاستعادة الآمن خلال",
  "The tag could not be read. Hold the phone still against it and try again.": "تعذّرت قراءة الوسم. ثبّت الهاتف عليه وحاول مرة أخرى.",
  "There is no AssetOS account for this email. Ask your administrator for an invitation.": "لا يوجد حساب AssetOS لهذا البريد الإلكتروني. اطلب دعوة من المسؤول.",
  "This account belongs to a different organisation. Use your email and password instead.": "ينتمي هذا الحساب إلى مؤسسة أخرى. استخدم بريدك الإلكتروني وكلمة المرور بدلاً من ذلك.",
  "This invitation could not be loaded": "تعذّر تحميل هذه الدعوة",
  "This invitation has already been used. Sign in with your organisation again.": "استُخدمت هذه الدعوة من قبل. سجّل الدخول عبر مؤسستك مرة أخرى.",
  "This invitation link is not valid": "رابط الدعوة هذا غير صالح",
  "This password reset link is missing its token.": "رابط إعادة تعيين كلمة المرور هذا يفتقد رمزه.",
  "This sign-in link is incomplete. Please sign in again.": "رابط تسجيل الدخول هذا غير مكتمل. يرجى تسجيل الدخول مرة أخرى.",
  "Toggle password visibility": "إظهار/إخفاء كلمة المرور",
  "Too many requests. Please try again in a few minutes.": "طلبات كثيرة جداً. يرجى المحاولة مرة أخرى بعد بضع دقائق.",
  "Unable to complete registration. Please review the errors below.": "تعذّر إكمال التسجيل. يرجى مراجعة الأخطاء أدناه.",
  "Unable to send the recovery link. Please try again.": "تعذّر إرسال رابط الاستعادة. يرجى المحاولة مرة أخرى.",
  "Unable to update your password. Please try again.": "تعذّر تحديث كلمة المرور. يرجى المحاولة مرة أخرى.",
  "Update Password": "تحديث كلمة المرور",
  "Updating...": "جارٍ التحديث...",
  "User Registration": "تسجيل مستخدم",
  "Uses your organisation’s sign-in. Only people your administrator has invited can get in.": "يستخدم تسجيل الدخول الخاص بمؤسستك. لا يدخل إلا من دعاهم المسؤول.",
  "Valid corporate email is required": "يلزم بريد إلكتروني صالح للشركة",
  "Weak": "ضعيفة",
  "Week": "الأسبوع",
  "Weekly summary of exception notes": "الملخص الأسبوعي لملاحظات الاستثناءات",
  "Welcome": "مرحباً",
  "Welcome back": "مرحباً بك مجدداً",
  "Work Orders & Repair Management": "أوامر العمل وإدارة الإصلاحات",
  "You can request a new link in {seconds}s": "يمكنك طلب رابط جديد خلال {seconds} ث",
  "You must accept the terms to create an account": "يجب قبول الشروط لإنشاء حساب",
  "You need to sign in to view this page.": "يجب تسجيل الدخول لعرض هذه الصفحة.",
  "Your account is ready": "حسابك جاهز",
  "Your invitation has been accepted and your access to the property is active. Sign in with your email and new password.": "تم قبول دعوتك وأصبح وصولك إلى العقار نشطاً. سجّل الدخول ببريدك الإلكتروني وكلمة المرور الجديدة.",
  "Your organisation confirmed who you are. Opening AssetOS.": "أكدت مؤسستك هويتك. جارٍ فتح AssetOS.",
  "Your organisation has not verified this email address.": "لم تتحقق مؤسستك من عنوان البريد الإلكتروني هذا.",
  "Your organisation is not set up for single sign-on. Use your email and password.": "مؤسستك غير مهيأة للدخول الموحد. استخدم بريدك الإلكتروني وكلمة المرور.",
  "Your role does not have permission to open this page.": "لا يملك دورك صلاحية فتح هذه الصفحة.",
  "{count} waiting to sync": "{count} بانتظار المزامنة",
  "{total} exception, {open} open, {resolved} resolved": "{total} استثناء، {open} مفتوح، {resolved} تمت معالجته",
  "{total} exceptions, {open} open, {resolved} resolved": "{total} استثناءات، {open} مفتوحة، {resolved} تمت معالجتها",
};
